import React, { useState, Fragment, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Table, TableHead, TableBody, TableRow, TableCell, CircularProgress } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AddIcon from '@material-ui/icons/Add';
import { globalPostService } from '../../../globalServices';
import { checkApiStatus } from '../../../utils_v2';

const sectionObj = { question: '', answer: '', notes:'' };
export default function AddQuestion({ params, addType, section, getDocumentCheckList, addQuestion, documentCheckList, questionList, getResponseBack, open, toggleModalFn }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [modal, setModal] = useState(open ? true : false);
    // const [duplicateError, setDuplicateError] = useState([]);
    const [error, setError] = useState([]);
    const [formData, setFormData] = useState([]);
    const onFieldChange = (keyParam, value, itemIndex) => {
        setFormData(formData.map((item, index) => index !== itemIndex ? item : { ...item, [keyParam]: value }));
    }
    useEffect(() => {
        setFormData([...formData, sectionObj])
    }, [])
    const onRemoveItem=(itemIndex)=>{
        setFormData(formData.filter((i,index)=> index !== itemIndex ))
    }
    const onSubmitAdd = async () => {
        let validationInput = {}
        validationInput= formData.map(item=> (
            {question:item?.question?.trim() ? '':'Please enter Question'})
        )
        let falseErrorFlag = validationInput.every(item=> item['question'] =='')
        if (falseErrorFlag) {
            setLoading(true)
            const response = await globalPostService(`technical/v2/workorder/${params?.workOrderSlug}/workbook/sections/${section?.id}/questions/?asset_type=${params?.type}`,formData)
            setLoading(false)
            if (checkApiStatus(response)) {
                toggleModalFn()
                getDocumentCheckList()
                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            }
        } else {
            setError(validationInput)
        }
    }
    const onAddNewItem =()=>{
        setFormData([...formData,sectionObj])
    }
    const resetErrorKey = (key, index) => {
        setError(error.map((item, itemIndex) => itemIndex !== index ? item : { ...item, [key]: '' }));
        // setDuplicateError([]);
    }
    return (
        <div>
            <Fragment>
                {/* <Button startIcon={<AddIcon color='primary' fontSize='small' />} onClick={(e) => { e.stopPropagation(); setModal(true); setFormData(addType === 'section' ? [sectionObj]: addType === 'sub-section' ? [subSectionObj]:[questionObj])}} color='primary' variant='outlined' size='small'>{addType === 'section'? 'Add Section': addType === 'sub-section' ? 'Add Sub Section':'Add Checklist'}</Button> */}
                {addQuestion?.modal ?
                    <Dialog
                        open={addQuestion?.modal}
                        maxWidth={'lg'}
                        className='project-management-modal'
                    >
                        <DialogTitle id="scroll-dialog-title">
                           Add Question(s)
                        </DialogTitle>
                        <DialogContent dividers={true}>
                            <div style={{ width: '680px' }}>
                                <Grid container spacing={1}>
                                    <Grid item md={12}>
                                        {/* {duplicateError.length ?
                                        <div>
                                            <h6>{addType === 'section'? 'Duplicate Section(s)': addType ==='sub-section' ? 'Duplicate Sub-Section(s)':'Duplicate Checklist(s)'}</h6>
                                            {duplicateError.map((err,errIndex) => <p className='error-msg'>- {err}</p>)}
                                        </div>:null
                                    } */}
                                        <Table className={'mui-table-format'}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Question(s) <sup>*</sup></TableCell>
                                                    {<TableCell>Answer(s)</TableCell>}
                                                    {<TableCell>Note(s)</TableCell>}
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {formData.map((item, index) =>
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            <TextField
                                                                id={`question_${index}`}
                                                                fullWidth
                                                                margin="none"
                                                                multiline
                                                                InputLabelProps={{ shrink: true }}
                                                                value={item.question ? item.question : ''}
                                                                error={error && error[index] && error[index].question ? true : false}
                                                                helperText={error && error[index] && error[index].question ? error[index].question : ''}
                                                                onChange={(e) => onFieldChange('question', e.target.value, index)}
                                                                onFocus={() => resetErrorKey('question', index)}
                                                                variant='outlined'
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                id={`answer_${index}`}
                                                                fullWidth
                                                                margin="none"
                                                                multiline
                                                                maxRows={4}
                                                                InputLabelProps={{ shrink: true }}
                                                                value={item.answer ? item.answer : ''}
                                                                onChange={(e) => onFieldChange('answer', e.target.value, index)}
                                                                variant='outlined'
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                id={`notes${index}`}
                                                                fullWidth
                                                                margin="none"
                                                                multiline
                                                                maxRows={4}
                                                                InputLabelProps={{ shrink: true }}
                                                                value={item.notes ? item.notes : ''}
                                                                onChange={(e) => onFieldChange('notes', e.target.value, index)}
                                                                variant='outlined'
                                                            />
                                                        </TableCell>
                                                        <TableCell style={{ width: '40px' }}>
                                                            <div style={{ width: '40px' }}>
                                                                {formData.length > 1 ?
                                                                    <DeleteOutlineIcon onClick={() => onRemoveItem(index)} color='secondary' fontSize='small' /> : null
                                                                }
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <Button startIcon={<AddIcon color='primary' fontSize='small' />} onClick={onAddNewItem} color='primary' variant='outlined' size='small' style={{ marginTop: '5px' }}>Add More</Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button disabled={isLoading} onClick={() => { toggleModalFn()}} color="primary" size='small' variant='outlined'>Cancel</Button>
                            <Button disabled={isLoading} onClick={onSubmitAdd} color="primary" size='small' variant='contained'>
                                {isLoading ? <CircularProgress size={24} color='primary' /> : 'Save'}
                            </Button>
                        </DialogActions>
                    </Dialog> : null
                }
            </Fragment>
        </div>
    )
}
